import type {BlockInstance} from '../appearance-data';

/** Free-form rich text / HTML content block. */
export function RichTextBlock({props}: {block: BlockInstance; props: Record<string, any>}) {
  const align = props.align === 'center' ? 'text-center' : props.align === 'end' ? 'text-end' : 'text-start';
  const width = props.max_width === 'narrow' ? 'max-w-720' : props.max_width === 'full' ? 'max-w-none' : 'max-w-[1100px]';
  return (
    <section className="px-24 py-40">
      <div
        className={`prose mx-auto ${width} ${align} [&_img]:rounded-lg`}
        dangerouslySetInnerHTML={{__html: props.content || ''}}
      />
    </section>
  );
}
